<template>
  <div>
    <v-card flat>

      <!-- Toolbar -->
      <v-toolbar color="blue darken-3 mx-3" dark dense flat>
        <v-btn small icon @click="$router.back()" class="mr-1">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-icon class="mr-2">mdi-file-chart-outline</v-icon>
        <v-toolbar-title class="font-weight-bold subtitle-1">
          {{ isbenitojuarez ? 'Reporte — Recibos Benito Juárez' : 'Reporte de Comprobantes de Pago' }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <span class="caption white--text d-flex align-center" v-if="user">
          <v-icon small class="mr-1">mdi-domain</v-icon>
          {{ $store.state.CARGO.sede.nombre }}
        </span>
      </v-toolbar>

      <v-card-text class="pb-0 px-4 pt-3">

        <!-- Panel de filtros -->
        <v-card outlined class="mb-3">
          <v-card-title class="py-2 px-3 blue lighten-5 subtitle-2 blue--text text--darken-3">
            <v-icon small left color="blue darken-3">mdi-filter-outline</v-icon>
            Filtros de búsqueda
          </v-card-title>
          <v-card-text class="pt-3 pb-2">
            <v-row dense align="center">
              <v-col cols="12" sm="2">
                <v-text-field
                  v-model.trim="busqueda.fecha_ini"
                  type="date"
                  label="Fecha desde"
                  outlined dense hide-details
                  prepend-inner-icon="mdi-calendar-start"
                />
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field
                  v-model.trim="busqueda.fecha_fin"
                  type="date"
                  label="Fecha hasta"
                  outlined dense hide-details
                  prepend-inner-icon="mdi-calendar-end"
                />
              </v-col>
              <v-col cols="12" sm="2">
                <Usuarios ref="user1" :current="false" :model="asesor" :xholder="'Asesor...'" />
              </v-col>
              <v-col cols="12" sm="2">
                <Usuarios ref="user2" :current="false" :model="emisor" :xholder="'Emisor...'" />
              </v-col>
              <v-col cols="auto">
                <v-checkbox
                  v-model="confirmado"
                  label="Confirmados"
                  hide-details dense class="mt-0"
                />
              </v-col>
              <v-col cols="auto" v-show="isnacional">
                <v-checkbox
                  v-model="allsedes"
                  label="Todas las sedes"
                  hide-details dense class="mt-0"
                  title="Solo se listarán las sedes de ESAM"
                />
              </v-col>
              <v-col cols="auto">
                <v-btn color="blue darken-3" dark rounded small @click="listarrecibos()">
                  <v-icon left small>mdi-magnify</v-icon>
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Loading -->
        <div class="text-center py-6" v-show="loading">
          <v-progress-circular indeterminate color="blue darken-3" size="40"></v-progress-circular>
          <div class="caption mt-2 grey--text">Cargando recibos...</div>
        </div>

        <!-- Barra de resultados y descarga -->
        <div class="d-flex align-center justify-space-between mb-2" v-if="recibos.length > 0 && !loading">
          <span class="caption grey--text">
            <v-icon small class="mr-1">mdi-table</v-icon>
            <strong>{{ recibos.length }}</strong> registros encontrados
          </span>
          <div>
            <download-excel
              v-if="!$store.state.isonlyread && unidad_negocio == 1"
              :data="recibos"
              :fields="isbenitojuarez ? json_fieldsbenito : json_fields"
              worksheet="Recibos"
              name="recibos.xls">
              <v-btn color="green darken-1" dark rounded small>
                <v-icon small left>mdi-microsoft-excel</v-icon>
                Descargar Excel
              </v-btn>
            </download-excel>
            <v-btn
              v-else-if="!$store.state.isonlyread"
              :disabled="$store.state.isonlyread"
              color="green darken-1" dark rounded small
              @click="tableToExcel('table', 'Lorem Table')">
              <v-icon small left>mdi-microsoft-excel</v-icon>
              Descargar Excel
            </v-btn>
          </div>
        </div>
      </v-card-text>

      <!-- Tabla de datos -->
      <div v-if="!loading && recibos.length > 0" class="px-4 pb-4">
        <div class="tabla-lista-recibos">
          <table ref="table" class="tabla-estilizada">
            <thead>
              <tr class="tabla-header manito">
                <th>Nro.</th>
                <th>FECHA REG.</th>
                <th v-show="false">NRO_CUOTA</th>
                <th v-if="unidad_negocio == 1 || isbenitojuarez">MATRÍCULA</th>
                <th v-if="unidad_negocio == 1 || isbenitojuarez">COLEGIATURA</th>
                <th v-if="unidad_negocio == 1 || isbenitojuarez">CURSO</th>
                <th v-if="unidad_negocio == 1 || isbenitojuarez">TRÁMITE DE CERTIFICACIÓN</th>
                <th v-if="unidad_negocio == 1">OTROS INGRESOS</th>
                <th
                  v-for="(d, indx) in columnas_dinamicas"
                  :key="indx"
                  class="col-dinamica">
                  {{ formatcolumnadinac(d) }}
                </th>
                <th>IMPORTE TOTAL</th>
                <th>Nº DE RECIBO</th>
                <th>N° FACTURA</th>
                <th>COD. CONTABILIDAD</th>
                <th>CARNET</th>
                <th>APELLIDOS Y NOMBRES</th>
                <th>TIPO DE PROGRAMA</th>
                <th>NOMBRE</th>
                <th>FORMA DE PAGO</th>
                <th>BANCOS</th>
                <th>N° CUENTA</th>
                <th>TIPO DE CUENTA</th>
                <th>NOMBRE DEL DEPOSITANTE</th>
                <th>N° DE COMPROBANTE</th>
                <th>CARNET DEPOSITANTE</th>
                <th>FECHA DEL PAGO</th>
                <th>EMISOR</th>
                <th>ASESOR</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r, ind) in recibos" :key="ind">
                <td :title="'ID: ' + r.id">{{ ind + 1 }}</td>
                <td>{{ r.fecha }}</td>
                <td v-show="false">{{ obtenerNumeroCuota(r) }}</td>
                <td v-if="unidad_negocio == 1 || isbenitojuarez">{{ r.matricula }}</td>
                <td v-if="unidad_negocio == 1 || isbenitojuarez">{{ r.colegiatura }}</td>
                <td v-if="unidad_negocio == 1 || isbenitojuarez">{{ r.curso }}</td>
                <td v-if="unidad_negocio == 1 || isbenitojuarez">{{ r.tramcertificacion }}</td>
                <td v-if="unidad_negocio == 1">{{ r.otrosingresos }}</td>
                <td v-for="(d, indx) in columnas_dinamicas" :key="indx">{{ r[d] }}</td>
                <td class="importe-total">{{ r.importetotal }}</td>
                <td>{{ r.recibo }}</td>
                <td>{{ r.factura }}</td>
                <td>{{ r.codigo_programa }}</td>
                <td>{{ r.numero_documento_estudiante }}</td>
                <td>{{ r.estudiante }}</td>
                <td>{{ r.tipoprograma }}</td>
                <td>{{ r.nombreprograma }}</td>
                <td>{{ r.formapago }}</td>
                <td>{{ r.banco }}</td>
                <td>{{ r.nrocuenta }}</td>
                <td>{{ r.tipocuenta }}</td>
                <td>{{ r.depositante }}</td>
                <td>{{ r.numero_comprobante }}</td>
                <td>{{ r.numero_documento_depositante }}</td>
                <td>{{ r.fechadelpago }}</td>
                <td>{{ r.emisor }}</td>
                <td>{{ r.asesor }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Estado vacío -->
      <div v-else-if="!loading" class="text-center py-12 grey--text">
        <v-icon x-large color="grey lighten-2">mdi-table-search</v-icon>
        <div class="body-2 mt-3">Seleccione un rango de fechas y presione <strong>Buscar</strong></div>
      </div>

      <show ref="refDetail"></show>
    </v-card>
  </div>
</template>

<style>
.tabla-lista-recibos {
  height: 68vh;
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.tabla-estilizada {
  width: 100%;
  border-collapse: collapse;
}
.tabla-estilizada thead tr.tabla-header {
  background-color: #1565c0 !important;
  color: #ffffff;
  position: sticky;
  top: 0;
  z-index: 50;
}
.tabla-estilizada thead th {
  padding: 9px 10px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  border-right: 1px solid #1976d2;
  letter-spacing: 0.3px;
}
.tabla-estilizada tbody tr:nth-child(even) {
  background-color: #e8f0fe;
}
.tabla-estilizada tbody tr:nth-child(odd) {
  background-color: #ffffff;
}
.tabla-estilizada tbody tr:hover {
  background-color: #bbdefb !important;
  cursor: default;
}
.tabla-estilizada tbody td {
  padding: 5px 8px;
  font-size: 12px;
  border-right: 1px solid #c5d0e8;
  white-space: nowrap;
}
.tabla-estilizada .importe-total {
  font-weight: bold;
  color: #2e7d32;
}
.col-dinamica {
  min-width: 120px;
  max-width: 150px;
  white-space: break-spaces !important;
}
</style>

<script>
  import Show from './Show';
  import Usuarios from '@/components/AUsuariosActivos';
  import { getheadersrest } from '@/components/Utils';
  import { similarity } from '@/components/cadenas.js';
  import gql from 'graphql-tag';

  export default {
    components: { Show, Usuarios },
    data() {
      return {
        uri: 'data:application/vnd.ms-excel;base64,',
        template:
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64: function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format: function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        },
        isbenitojuarez: false,
        unidad_negocio: 1,
        isnacional: false,
        menu_name: process.env.VUE_APP_NAME_MENU,
        api_rest: process.env.VUE_APP_API_REST,
        user: null,
        recibos: [],
        busqueda: { fecha_ini: '', fecha_fin: '' },
        loading: false,
        confirmado: true,
        allsedes: false,
        columnas_dinamicas: [],
        asesor: { idusuario: {} },
        emisor: { idusuario: {} },
        json_fields: {
          FECHA: 'fecha',
          NRO_CUOTA: 'concepto',
          MATRÍCULA: 'matricula',
          COLEGIATURA: 'colegiatura',
          CURSO: 'curso',
          'TRÁMITE DE CERTIFICACIÓN': 'tramcertificacion',
          'OTROS INGRESOS': 'otrosingresos',
          'IMPORTE TOTAL': 'importetotal',
          'Nº DE RECIBO': 'recibo',
          'N° FACTURA': 'factura',
          'COD. CONTABILIDAD': 'codigo_programa',
          CARNET: 'numero_documento_estudiante',
          'APELLIDOS Y NOMBRES': 'estudiante',
          'TIPO DE PROGRAMA': 'tipoprograma',
          NOMBRE: 'nombreprograma',
          'FORMA DE PAGO': 'formapago',
          BANCOS: 'banco',
          'N° CUENTA': 'nrocuenta',
          'TIPO DE CUENTA': 'tipocuenta',
          'NOMBRE DEL DEPOSITANTE': 'depositante',
          'N° DE COMPROBANTE': 'numero_comprobante',
          'CARNET DEPOSITANTE': 'numero_documento_depositante',
          'FECHA DEL PAGO': 'fechadelpago',
          EMISOR: 'emisor',
          ASESOR: 'asesor',
        },
        json_fieldsbenito: {
          FECHA: 'fecha',
          'OTROS INGRESOS': 'otrosingresos',
          'IMPORTE TOTAL': 'importetotal',
          'Nº DE RECIBO': 'recibo',
          'N° FACTURA': 'factura',
          'COD. CONTABILIDAD': 'codigo_programa',
          CARNET: 'numero_documento_estudiante',
          'APELLIDOS Y NOMBRES': 'estudiante',
          'TIPO DE PROGRAMA': 'tipoprograma',
          NOMBRE: 'nombreprograma',
          'FORMA DE PAGO': 'formapago',
          BANCOS: 'banco',
          'N° CUENTA': 'nrocuenta',
          'TIPO DE CUENTA': 'tipocuenta',
          'NOMBRE DEL DEPOSITANTE': 'depositante',
          'N° DE COMPROBANTE': 'numero_comprobante',
          'CARNET DEPOSITANTE': 'numero_documento_depositante',
          'FECHA DEL PAGO': 'fechadelpago',
          EMISOR: 'emisor',
          ASESOR: 'asesor',
        },
        json_meta: [
          [
            {
              key: 'charset',
              value: 'utf-8',
            },
          ],
        ],
      };
    },
    watch: {
      '$store.state.CARGO': function () {
        this.asesor.idusuario = {};
        this.emisor.idusuario = {};
        this.$refs.user1.getDatos();
        this.$refs.user2.getDatos();
        this.listarrecibos();
      },
      '$route.name': function () {
        this.isbenitojuarez = location.href.includes('recibosbenito');
      },
    },
    methods: {
      openDialogDetail(recibo) {
        this.$refs.refDetail.showThisView(recibo);
      },
      paddingceros(num, places) {
        if (num == 0) return '';
        if (!num) return '';
        let res = String(num).padStart(places, '0');
        return res;
      },
      tableToExcel(table, name) {
        if (!table.nodeType) table = this.$refs.table;
        var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };
        var link = document.createElement('a');
        link.download = 'recibos-cca.xls';
        link.href = this.uri + this.base64(this.format(this.template, ctx));
        link.click();
      },
      formatcolumnadinac(str) {
        let indice = str.lastIndexOf('-');
        let text = str;
        if (indice > 0) text = text.substring(0, indice);
        return text;
      },
      parsefecha(f) {
        if (!f) return '';
        let fs = [];
        if (f.includes(' ')) {
          let ff = f.split(' ');
          fs = ff[0].split('-');
        } else {
          fs = f.split('-');
        }
        return fs[2] + '/' + fs[1] + '/' + fs[0];
      },
      blankiscero(valor) {
        if (!valor) return ''; 
        valor = this.addSeparatorsNF(valor, '.', ',', '.');
        return valor;
      },
      tonumberdecimal(n) {
        n = n.replace(/\./g, '').replace(',', '.');
        return !isNaN(parseFloat(n)) && isFinite(n);
      },
      addSeparatorsNF(nStr, inD, outD, sep) {
        nStr = Number(nStr).toFixed(2);
        nStr += '';
        var dpos = nStr.indexOf(inD);
        var nStrEnd = '';
        if (dpos != -1) {
          nStrEnd = outD + nStr.substring(dpos + 1, nStr.length);
          nStr = nStr.substring(0, dpos);
        }
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(nStr)) {
          nStr = nStr.replace(rgx, '$1' + sep + '$2');
        }
        return nStr + nStrEnd;
      },
      listarrecibos() {
        if (!this.busqueda.fecha_ini || !this.busqueda.fecha_fin) {
          return;
        }
        const vue = this;
        vue.recibos = [];
        vue.loading = true;
        let fs1 = this.busqueda.fecha_ini.split('-');
        let fs2 = this.busqueda.fecha_fin.split('-');
        let fecha1 = fs1[2] + '/' + fs1[1] + '/' + fs1[0];
        let fecha2 = fs2[2] + '/' + fs2[1] + '/' + fs2[0];

        let myHeaders = getheadersrest();
        if (!this.asesor.idusuario) this.asesor.idusuario = {};
        if (!this.emisor.idusuario) this.emisor.idusuario = {};
        let idasesorsel = this.asesor.idusuario.id;
        let idemisorsel = this.emisor.idusuario.id;
        let idsede = this.$store.state.CARGO.idsede;
        this.columnas_dinamicas = [];
        this.unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
        if (this.unidad_negocio == 10) this.unidad_negocio = 1;
        let fil = {
          asesor_id: idasesorsel,
          emisor_id: idemisorsel,
          sede_id: idsede,
          confirmado: this.confirmado,
          fecha_inicio: fecha1,
          fecha_fin: fecha2,
          estado: true,
        };
        if (this.allsedes) delete fil.sede_id;
        if (!idasesorsel) delete fil.asesor_id;
        if (!idemisorsel) delete fil.emisor_id;

        var raw = JSON.stringify(fil);

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow',
        };

        window.console.log(fil, this.$store.state.CARGO);

        fetch(this.api_rest + '/api/pagos/recibos/reporte', requestOptions)
          .then((response) => response.json())
          .then((result) => {
            vue.loading = false;
            window.console.log('RECIBOS:\n', result);
            if (!result) return;
            if (vue.allsedes && vue.unidad_negocio == 1) {
              result = vue.filtrarsoloesam(result);
            }

            result.sort((a, b) => new Date(b.fecha_registro) - new Date(a.fecha_registro));

            result.forEach(function (p) {
              let pago = {};
              let importetotal = 0;
              pago.id = p.id;
              pago.fecha = vue.parsefecha(p.fecha_registro);
              pago.recibo = vue.paddingceros(p.numero_recibo, 6);
              let fact_pad = vue.paddingceros(p.numero_factura, 7);
              pago.factura = fact_pad;
              pago.codigo_programa = p.codigo_programa;
              pago.estudiante = p.estudiante;
              pago.numero_documento_estudiante = p.numero_documento_estudiante;
              pago.tipoprograma = p.tipo_programa;
              pago.nombreprograma = p.nombre_programa;
              if (p.forma_pago_id == 1) pago.formapago = 'EFECTIVO';
              else if (p.forma_pago_id == 2) pago.formapago = 'TRANSFERENCIA';
              else if (p.forma_pago_id == 3) pago.formapago = 'TIGO MONEY';
              else if (p.forma_pago_id == 4) pago.formapago = 'MULTIPAGO';
              pago.banco = p.banco;
              pago.nrocuenta = p.numero_cuenta;
              pago.tipocuenta = p.tipo_cuenta;
              pago.depositante = p.nombre_depositante;
              pago.numero_comprobante = p.numero_comprobante;
              pago.numero_documento_depositante = p.numero_documento_depositante;
              pago.fechadelpago = vue.parsefecha(p.fecha_pago);
              pago.emisor = p.emisor;
              pago.asesor = p.asesor;

              pago.tramcertificacion = 0;
              pago.colegiatura = 0;
              pago.concepto = '?';
              pago.matricula = 0;
              pago.curso = 0;
              pago.otrosingresos = 0;

              p.detalle.sort((a, b) => {
                return a.concepto_pago_id - b.concepto_pago_id;
              });

              p.detalle.forEach(function (d) {
                if (vue.unidad_negocio == 1) {
                  if (p.nombre_programa.includes('Esam Cursos')) {
                    pago.curso += Number(d.monto);
                  } else if (d.concepto_pago_id == 3) {
                    pago.tramcertificacion += Number(d.monto);
                  } else if (pago.tipoprograma == 'Curso') {
                    pago.curso += Number(d.monto);
                  } else if (d.concepto_pago_id == 1) {
                    pago.matricula += Number(d.monto);
                  } else if (d.concepto.includes('Curso')) {
                    pago.curso += Number(d.monto);
                  } else if (d.concepto_pago_id == 2) {
                    pago.colegiatura += Number(d.monto);
                  } else if (d.opcional || d.concepto_pago_id == 19 || d.concepto_pago_id == 28) {
                    pago.otrosingresos += Number(d.monto) * Number(d.cantidad);
                  } else {
                    pago.otrosingresos += Number(d.monto) * Number(d.cantidad);
                    window.console.log('CONCEPTO DESCONOCIDO(agregado a otros ingresos)>', d);
                  }
                  importetotal =
                    pago.tramcertificacion + pago.matricula + pago.curso + pago.colegiatura + pago.otrosingresos;
                } else {
                  importetotal += Number(d.monto) * Number(d.cantidad);

                  let existe = vue.columnas_dinamicas.find((x) => {
                    let simulitud = similarity(x, d.concepto);
                    if (simulitud > 0.82) return x;
                    else return false;
                  });

                  if (!existe) { 
                    vue.columnas_dinamicas.push(d.concepto);
                    if (!pago[d.concepto]) pago[d.concepto] = 0;
                    pago[d.concepto] = parseFloat((pago[d.concepto] + Number(d.monto) * d.cantidad).toFixed(2));
                  } else {
                    if (!pago[existe]) pago[existe] = 0;
                    pago[existe] = parseFloat((pago[existe] + Number(d.monto) * d.cantidad).toFixed(2));
                  }
                }
                pago.cantidad = d.cantidad;
                pago.xconcepto = d.concepto;
                pago.concepto = vue.obtenerNumeroCuota(d.concepto);
              });
              pago.importetotal = vue.blankiscero(importetotal);
              pago.tramcertificacion = vue.blankiscero(pago.tramcertificacion);
              pago.colegiatura = vue.blankiscero(pago.colegiatura);
              pago.matricula = vue.blankiscero(pago.matricula);
              pago.curso = vue.blankiscero(pago.curso);
              pago.otrosingresos = vue.blankiscero(pago.otrosingresos);
              pago.estado = p.estado;
              vue.recibos.push(pago);
            });
          })
          .catch((e) => {
            vue.loading = false;
            window.console.log(e);
          });
      },
      getsimilaradd() {},
      filtrarsoloesam(result) {
        window.console.log('Filtrar las sedes ok...', result);
        result = result.filter((x) => {
          return x.sede_id != 10;
        });
        return result;
      },

      obtenerNumeroCuota(concepto_name){
        if(typeof(concepto_name) == 'object') {
          concepto_name = concepto_name.xconcepto;
        }
        if(typeof(concepto_name) == 'object') return '-';

        const match = concepto_name.match(/-? ?(\d+)$/);
        let numero;
        if (match && match[1]) {
          numero = parseInt(match[1], 10);
          return numero;
        }
        return '?';
      },

      async getconceptospagos(idunidad) {
        if (!idunidad) {
          this.loading = false;
          return;
        }
        var vue = this;
        var sql = gql`query{ConceptoPagoAll(unidad_negocio_id:${idunidad}){id,nombre,monto,estado,facturable,opcional}}`;
        await this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            let datos = data.data.ConceptoPagoAll;
            window.console.log(datos, vue.$store.state.CARGO.sede);
            vue.listarrecibos();
          })
          .catch((error) => {
            window.console.error(error);
          });
      },
    },
    mounted() {
      this.isbenitojuarez = location.href.includes('recibosbenito');
      this.user = this.$store.state.DATA_USER;
      if (this.user.id == 31 || this.user.id == 1099 || this.user.id == 6457 || this.user.id == 1) {
        this.isnacional = true;
      }
      let hoy = new Date();
      let pasado = new Date();
      pasado.setDate(hoy.getDate() - 7);
      let d1 = hoy.getDate();
      let m1 = hoy.getMonth() + 1;
      let a1 = hoy.getFullYear();
      let d2 = pasado.getDate();
      let m2 = pasado.getMonth() + 1;
      let a2 = pasado.getFullYear();
      if (d1 < 10) d1 = '0' + d1;
      if (d2 < 10) d2 = '0' + d2;
      if (m1 < 10) m1 = '0' + m1;
      if (m2 < 10) m2 = '0' + m2;
      this.busqueda.fecha_ini = a2 + '-' + m2 + '-' + d2;
      this.busqueda.fecha_fin = a1 + '-' + m1 + '-' + d1;
      this.unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
      this.getconceptospagos(this.unidad_negocio);

      const getCellValue = (tr, idx) => tr.children[idx].innerText || tr.children[idx].textContent;
      const comparer = (idx, asc) => (a, b) =>
        ((v1, v2) => (v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ? v1 - v2 : v1.toString().localeCompare(v2)))(
          getCellValue(asc ? a : b, idx),
          getCellValue(asc ? b : a, idx),
        );
      document.querySelectorAll('th').forEach((th) =>
        th.addEventListener('click', () => {
          const table = th.closest('table');
          const tbody = table.querySelector('tbody');
          Array.from(tbody.querySelectorAll('tr'))
            .sort(comparer(Array.from(th.parentNode.children).indexOf(th), (this.asc = !this.asc)))
            .forEach((tr, ind) => {
              tr.firstChild.innerHTML = ind + 1;
              tbody.appendChild(tr);
            });
        }),
      );
    },
  };
</script>
